import $ from 'jquery';

const scrollToProduct = () => {
	const el = {
		button: '#navigate-button',
		container: '#products',
	};

	const offset = 200;

	if (!$(el.button).length) return;

	$(el.button).on('click', function (e) {
		e.preventDefault();

		if ($(el.container).length) {
			$('html, body').animate(
				{
					scrollTop: $(el.container).offset().top - offset,
				},
				300,
			);
			history.pushState(
				'',
				document.title,
				window.location.pathname + window.location.search,
			);
		}
	});
};

try {
	scrollToProduct();
} catch (error) {
	console.log(error);
}
